<template>
  <!-- 个人订单续约 -->
  <rentInfoB
    :orderType="orderType"
    :submitText="orderObj[orderType].submitText"
    :submitApi="submitApi"
    :params="orderObj[orderType].params"
    :list="orderObj[orderType].list"
    :source="orderObj[orderType].source"
    @orderCreateSuccess="orderCreateSuccess"
  />
</template>

<script>
import { addEnterpriseSubOrderRenewalSignCheck, addEnterpriseSubOrderRenewalBSignCheck, addPersonalOrderRenewalBSignCheck } from '@/api/domain/underLease'
import rentInfoB from '../../components/rentInfo/rentInfo/indexB.vue'
import { ORDER_TYPE } from './const'

export default {
  name: 'orderRenewalAddRentInfo',
  components: { rentInfoB },
  props: {
    orderType: {
      type: String,
      default: '',
    },
    orderDataList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      switchData: null,
      orderObj: {
        personal: {
          orderTypeName: '个人租赁订单',
          list: [
            { name: '原订单ID', key: 'id' },
            { name: '车牌号', key: 'plateNo' },
            { name: '客户姓名', key: 'customerName' },
            { name: '原计租起止日', key: 'rentRangeTime' }, // todo
            { name: '原每期租金', key: 'rentAmount' }, // todo
            { name: '原押金', key: 'totalDeposit' }, // todo
          ],
          source: {},
          params: {
            customerId: '',
            modelId: '',
            carId: '',
            relatedOrderId: '', // 续约时原订单ID
            signType: '', // 原订单签署类型
          },
          submitText: '下一步发起合同签署',
          dealMethods: this.dealPersonalData,
        }, // 个人
        enterpriseSub: {
          orderTypeName: '企业租赁订单',
          list: [
            { name: '企业主订单ID', key: 'entRentOrderId' },
            { name: '车牌号', key: 'plateNo' },
            { name: '客户姓名', key: 'customerName' },
            { name: '原收款起止日期', key: 'rentRangeTime' },
          ],
          params: {
            customerId: '',
            orderId: '',
            carInfoList: [],
          },
          source: {},
          submitText: '确认',
          dealMethods: this.dealEntData,
        }, // 企业子
        enterpriseSubBatch: {
          orderTypeName: '企业租赁子订单',
          list: [
            { name: '企业主订单ID', key: 'entRentOrderId' },
            { name: '原计租/免租结束日期', key: 'rentRangeTime' }, // todo
            { name: '续约车辆数', key: 'count' }, // todo
          ],
          params: {
            customerId: '',
            orderId: '',
            carInfoList: [],
          },
          source: {},
          submitText: '确认',
          dealMethods: this.dealEntBatchData,
        }, // 企业子批量
      },
    }
  },
  computed: {
    deposit() {
      return this.orderDataList?.deposit || this.orderDataList[0]?.depositReceivedVO || {}
    },
    submitApi() {
      if (this.orderType === ORDER_TYPE.Personal) { // 个人
        return addPersonalOrderRenewalBSignCheck
      }
      if (this.orderType === ORDER_TYPE.EnterpriseSub) { // 企业子
        return this.switchData ? addEnterpriseSubOrderRenewalBSignCheck : addEnterpriseSubOrderRenewalSignCheck
      }
      if (this.orderType === ORDER_TYPE.EnterpriseSubBatch) { // 企业子订单批量
        return addEnterpriseSubOrderRenewalSignCheck
      }
      return addPersonalOrderRenewalBSignCheck
    },
  },
  provide() {
    return {
      deposit: this.deposit,
    }
  },
  created() {
    this.orderObj[this.orderType].dealMethods && this.orderObj[this.orderType].dealMethods()
  },
  methods: {
    // 处理个人相关数据
    dealPersonalData() {
      const orderInfo = this.orderDataList[0]
      // 计租起止日
      const { startDate = '--', endDate = '--' } = orderInfo
      this.orderObj[this.orderType].source.rentRangeTime = `${startDate}~${endDate}`
      // 设置params
      const { params, source } = this.orderObj[this.orderType]
      Object.keys(params).forEach((key) => {
        this.$set(params, key, orderInfo[key])
        if (key === 'relatedOrderId') {
          this.$set(params, key, orderInfo.id)
        }
      })
      // 设置source
      Object.keys(orderInfo).forEach((key) => {
        this.$set(source, key, orderInfo[key])
      })
      // 每期租金 (租赁方案性质为阶梯方案显示第一阶梯的金额)
      if (orderInfo?.feeConfig?.feePiecewiseCalculation?.isOpen) {
        this.orderObj[this.orderType].source.rentAmount = `${orderInfo.feeConfig.feePiecewiseCalculation.feePiecewiseConfigList[0].amount}元`
      } else {
        this.orderObj[this.orderType].source.rentAmount = `${orderInfo.rentAmount || '0.00'}元`
      }
      // 原押金
      this.orderObj[this.orderType].source.totalDeposit = `${orderInfo.totalDeposit || '0.00'}元`
      // this.getDeposit(orderInfo.id)
    },
    // 处理企业子订单相关数据
    dealEntData() {
      const orderInfo = this.orderDataList[0]
      // 计租起止日
      const { startDate = '--', endDate = '--' } = orderInfo
      this.orderObj[this.orderType].source.rentRangeTime = `${startDate}~${endDate}`
      // 设置params
      const { params, source } = this.orderObj[this.orderType]
      Object.keys(params).forEach((key) => {
        this.$set(params, key, orderInfo[key])
        // 企业主订单ID
        if (key === 'orderId') {
          this.$set(params, key, orderInfo.entRentOrderId)
        }
      })
      // 获取carInfoList
      params.carInfoList = []
      this.orderDataList.forEach((order) => {
        const { carId, modelId } = order
        params.carInfoList.push({
          id: carId,
          modelId,
          relatedOrderId: order.id,
        })
      })
      // 设置source
      Object.keys(orderInfo).forEach((key) => {
        this.$set(source, key, orderInfo[key])
      })
      // this.getDeposit(orderInfo.id)
    },
    // 处理企业子订单批量相关数据
    dealEntBatchData() {
      const orderInfo = this.orderDataList[0]
      const { endDate = '--', presentEntDate = '--' } = orderInfo
      // 原计租/免租结束日期
      this.orderObj[this.orderType].source.rentRangeTime = presentEntDate || endDate
      // 续约车辆数
      this.orderObj[this.orderType].source.count = this.orderDataList.length || 0
      this.orderObj[this.orderType].source.entRentOrderId = orderInfo.entRentOrderId
      const { params, source } = this.orderObj[this.orderType]
      Object.keys(params).forEach((key) => {
        this.$set(params, key, orderInfo[key])
        // 企业主订单ID
        if (key === 'orderId') {
          this.$set(params, key, orderInfo.entRentOrderId)
        }
      })
      // 设置source
      Object.keys(orderInfo).forEach((key) => {
        this.$set(source, key, orderInfo[key])
      })
      // 获取carInfoList
      params.carInfoList = []
      this.orderDataList.forEach((order) => {
        const { carId, modelId } = order
        params.carInfoList.push({
          id: carId,
          modelId,
          relatedOrderId: order.rentOrderId,
        })
      })

      /* this.$nextTick(() => {
        this.deposit.depositReceived = this.orderDataList.deposit ? +this.orderDataList.deposit.depositReceived : 0
        this.deposit.flag = this.orderDataList.deposit ? this.orderDataList.deposit.flag : false
      }) */
    },
    // 获取原订单已收押金金额
    /* getDeposit (id) {
      getRentOrderDepositReceived({
        oldOrderId: id
      }).then(res => {
        this.deposit.depositReceived = res.data ? +res.data.depositReceived : 0
        this.deposit.flag = res.data ? res.data.flag : false
      })
    }, */
    // 订单创建成功后的回调
    orderCreateSuccess(data) {
      // 个人订单
      if (this.orderType === ORDER_TYPE.Personal) {
        this.$emit('completeRentInfoFillin', [data])
        return
      }
      // 企业订单续约成功
      this.$refreshBack(true)
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
